import { gql } from '@efficiently/client-core-graphql-models';

export const UPLOAD_CROPPER_CONTENT = gql(`
	mutation UploadCropperContent($args: CropperContentUploadArgs!) {
		uploadCropperContent(args: $args) {
			content {
				...ContentDomainContentFields
			}
			cropper {
				...ContentCropperFields
			}
		}
	}
`);
